export const DECIMAL_BYTE_UNIT = 1000;
export const BYTES_PER_GIGABYTE = DECIMAL_BYTE_UNIT * DECIMAL_BYTE_UNIT * DECIMAL_BYTE_UNIT;

export const formatBytes = (bytes, decimals = 2, base = 1024) => {
	if (bytes === 0) {
		return '0 Bytes';
	}

	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(base));

	return parseFloat((bytes / Math.pow(base, i)).toFixed(dm)) + ' ' + sizes[i];
};

/** Format traffic and storage for billing/usage with decimal SI units (1 GB = 10^9 bytes). */
export const formatUsageBytes = (bytes, decimals = 2) => formatBytes(bytes, decimals, DECIMAL_BYTE_UNIT);
